<div class="sidebar-detail" role="dialog" aria-label="Asset Balance">
  <div class="sidebar-panel">
    <div class="panel-title">
      Asset Balance
      <button #closeButton type="button" class="close-icon" aria-label="Close asset balance" (click)="closed.emit()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="sidebar-content">
      @if (isLoading || metadata.isLoading()) {
        <div class="asset-list" aria-busy="true">
          @for (_ of skeletonRows; track $index) {
            <div class="asset-row skeleton-row"></div>
          }
        </div>
      } @else if (error || metadata.error()) {
        <p class="drawer-empty drawer-error" role="alert">{{ error || metadata.error() }}</p>
      } @else if (!assets().length) {
        <p class="drawer-empty">No balances to show.</p>
      } @else {
        <div class="asset-list">
          @for (asset of assets(); track asset.asset) {
            <div class="asset-block">
              <div
                class="asset-row"
                [class.expandable]="asset.entries.length > 1"
                [attr.role]="asset.entries.length > 1 ? 'button' : null"
                [attr.tabindex]="asset.entries.length > 1 || asset.entries[0].riskDistribution?.length ? 0 : null"
                [attr.aria-expanded]="asset.entries.length > 1 ? isExpanded(asset) : null"
                (click)="toggleAsset(asset)"
                (keydown.enter)="toggleAsset(asset)"
                (keydown.space)="$event.preventDefault(); toggleAsset(asset)"
                (mouseenter)="asset.entries.length === 1 && showRisk(asset.entries[0], $event)"
                (mouseleave)="asset.entries.length === 1 && hideRisk()"
                (focus)="asset.entries.length === 1 && showRisk(asset.entries[0], $event)"
                (blur)="asset.entries.length === 1 && hideRisk()"
              >
                <app-currency-icon [iconKey]="asset.iconKey" [label]="asset.asset" [size]="22" />
                <span class="asset-ticker">{{ asset.asset }}</span>
                @if (asset.name) {
                  <span class="asset-name">({{ asset.name }})</span>
                }
                @if (asset.total | splitParts: asset.precision; as parts) {
                  <span class="asset-amount olv-figure">
                    {{ parts.integer }}<span class="amount-decimal">{{ parts.decimal }}</span>
                  </span>
                }
                @if (asset.entries.length > 1) {
                  <mat-icon class="chevron" [class.collapsed]="!isExpanded(asset)">expand_more</mat-icon>
                }
              </div>

              @if (asset.entries.length > 1 && isExpanded(asset)) {
                <div class="network-list">
                  @for (entry of asset.entries; track entry.currencyId) {
                    <div
                      class="network-entry"
                      [attr.tabindex]="entry.riskDistribution?.length ? 0 : null"
                      (mouseenter)="showRisk(entry, $event)"
                      (mouseleave)="hideRisk()"
                      (focus)="showRisk(entry, $event)"
                      (blur)="hideRisk()"
                    >
                      <app-currency-icon
                        [iconKey]="entry.iconKey"
                        [networkIconKey]="entry.networkIconKey"
                        [label]="entry.label"
                        [size]="16"
                      />
                      <div class="network-details">
                        <span class="network-label">{{ entry.label }}</span>
                        @if (entry.totalAmountInCurrency | splitParts: entry.currencyDisplayPrecision; as parts) {
                          <span class="network-amount olv-figure">
                            {{ parts.integer }}<span class="amount-decimal">{{ parts.decimal }}</span>
                          </span>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>

@if (hoveredEntry) {
  <div
    class="risk-popup"
    #riskPopup
    [style.left.px]="popupLeft"
    (mouseenter)="keepRiskOpen()"
    (mouseleave)="hideRisk()"
  >
    <app-risk-distribution-tooltip [currency]="hoveredEntry" [compact]="true" />
  </div>
}
